import { apiClient } from '@/shared/lib/apiClient';
import { PLATFORM_USAGE_RECENT_LIMIT, PLATFORM_USAGE_SUMMARY_MINUTES } from '../constants';
import type {
  PlatformUsageLiveResponse,
  PlatformUsageRecentEvent,
  PlatformUsageSummary,
} from '../types';

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export async function fetchPlatformUsageLive(
  signal?: AbortSignal,
): Promise<PlatformUsageLiveResponse> {
  const res = await apiClient.get<ApiResponse<PlatformUsageLiveResponse>>(
    '/api/v1/platform-usage/live',
    signal ? { signal } : undefined,
  );
  return res.data;
}

export async function fetchPlatformUsageRecent(
  limit = PLATFORM_USAGE_RECENT_LIMIT,
  signal?: AbortSignal,
): Promise<PlatformUsageRecentEvent[]> {
  const res = await apiClient.get<ApiResponse<PlatformUsageRecentEvent[]>>(
    '/api/v1/platform-usage/recent',
    {
      params: { limit: String(limit) },
      ...(signal ? { signal } : {}),
    },
  );
  return res.data;
}

export async function fetchPlatformUsageSummary(
  minutes = PLATFORM_USAGE_SUMMARY_MINUTES,
  signal?: AbortSignal,
): Promise<PlatformUsageSummary> {
  const res = await apiClient.get<ApiResponse<PlatformUsageSummary>>(
    '/api/v1/platform-usage/summary',
    {
      params: { minutes: String(minutes) },
      ...(signal ? { signal } : {}),
    },
  );
  return res.data;
}
